import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { byteSizePipe } from '../../pipes/byteSize.pipe';
import { ReadableDateComparedWithTodayPipe } from '../../pipes/readable-date-compared-with-today.pipe';
import { SortByPipe } from '../../pipes/sortby.pipe';
import { TextFilterPipe } from '../../pipes/textfilter.pipe';
import { TimeAgoPipe } from '../../pipes/timeAgo';
import { FilterPipe } from '../../pipes/filter.pipe';
import { PdfPreparationDialogForBuilder, PdfPreparationDialogForStatus } from '../../components/general/pdf-preparation-dialog/pdf-preparation-dialog.component';
import { NgbModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularDraggableModule } from 'angular2-draggable';
import { NgxPanZoomModule } from 'ngx-panzoom';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpLoaderFactory } from '../../_helpers/translate-loader.factory';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { InfoButtonComponent, DangerInfoButtonComponent, CloseableInfoButtonComponent } from 'src/app/components/info-button/info-button.component';
import { ToastsContainer } from 'src/app/components/general/toast/toast.component';
import { ActionToThePastTranslationKeyPipe } from 'src/app/pipes/action-to-the-past-translation-key.pipe';
import { ActionToTranslationKeyPipe } from 'src/app/pipes/action-to-translation-key.pipe';
import { StatusDisplayComponent } from 'src/app/components/status-display/status-display.component';
import { BadgeStatusDisplayComponent } from 'src/app/components/status-display/badge-status-display.component';
import { GreetUserComponent } from 'src/app/components/general/greet-user/greet-user.component';
import { ActionSummaryComponent } from 'src/app/components/performaction/components/action-summary.component';
import { FormcontrolErrorMessagesComponent } from 'src/app/components/formcontrol-error-messages/formcontrol-error-messages.component';
import { ViewXbrlOrTxtModal } from 'src/app/modals/view-xbrl/view-xbrl-or-txt.modal';
import { BreadcrumbComponent } from 'src/app/components/breadcrumb/breadcrumb.component';
import { RouterLink, RouterLinkActive, RouterModule, RouterOutlet } from '@angular/router';
import { InputTrimDirective, TrimDirective } from 'src/app/directives/inputTrim.directive';
import { DisplayAmountBasedTranslation } from 'src/app/components/display-singular-plural-translation/display-amount-based-translation.component';
import { LoadingSpinnerComponent } from 'src/app/components/loading-spinner.component.ts/loading-spinner.component';
import { PageSizePickerComponent } from 'src/app/components/page-size-picker/page-size-picker.component';
import { ViewXmlModal } from 'src/app/modals/view-xbrl/view-xml.modal';
import { MobileOverlayComponent } from 'src/app/components/general/mobile-overlay/mobile-overlay.component';
import { TagStringInputComponent } from 'src/app/components/general/tag-string-input/tag-string-input.component';
import { TagInputModule } from 'ngx-chips';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { DesktopStatusActions, MobileStatusActions } from 'src/app/components/requeststatus/components/status-actions/status-actions.component';
import { DefaultMobileTableComponent, DefaultTableComponent } from 'src/app/components/general/table/base_table_default.component';
import { DesktopStatusLogComponent, MobileStatusLogComponent } from 'src/app/components/general/table/base_status_log.component';
import { StatusActionsTableDesktopComponent, StatusActionsTableMobileComponent } from 'src/app/components/general/table/base_table_status_actions.component';
import { StatusInfoTableDesktopComponent, StatusInfoTableMobileComponent } from 'src/app/components/general/table/base_table_status_info.component';
import { ValueByTypePipe } from 'src/app/pipes/value-by-type.pipe';
import { DeadlineComponent } from 'src/app/components/general/deadline/deadline.component';
import { PillBadgeStatusDisplayComponent } from 'src/app/components/status-display/pillbadge-status-display.component';
import { BuilderSendgroupTableActionsDesktopComponent } from 'src/app/components/requestbuilder/step-4/send-group/sendgroup-table/sendgroup-action-table/desktop_table_builder_sendgroup_actions.component';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { MobileRequestStatusSendgroupActionsComponent } from 'src/app/components/requeststatus/components/status-sendgroups/request-status-sendgroup-item/request-status-actions-by-person/request-status-sendgroup-action-row/mobile-request-status-sendgroup-action-row.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OwlDateTimeIntl } from '@danielmoncada/angular-datetime-picker';
import { DateTimePickerComponent, DefaultIntl } from 'src/app/components/general/datetime-picker/datetime-picker.component';
import { SafeTranslateDirective } from 'src/app/directives/SafeTranslate.directive';
import { DocumentDetailsModal } from 'src/app/modals/document-details/document-details.modal';
import { ViewLongStringModal } from 'src/app/modals/view-long-string/view-long-string.modal';
import { ClosableWrapperComponent } from 'src/app/components/general/closable-wrapper/closable-wrapper.component';
import { AutofocusDirective } from 'src/app/directives/appAutofocus.directive';
import { ColumnResizeDirective } from 'src/app/directives/column-resize.directive';
import { ModalWrapperComponent } from 'src/app/modals/modal-wrapper.component';
import { EditFilingDataModalComponent } from 'src/app/modals/edit-filing-data-modal/edit-filing-data-modal.component';
import { A11yModule } from "@angular/cdk/a11y";
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { StringHelper } from 'src/app/directives/string-helper';
import { LanguagePickerComponent } from 'src/app/components/general/language-picker/language-picker.component';
import { BuilderBadgeComponent } from 'src/app/components/status-display/builder-badge.component';
import { CreateSupportTicketModal } from 'src/app/modals/create-support-ticket/create-support-ticket.modal';
import { CloudDocumentUploadModal } from 'src/app/modals/cloud-document/cloud-document-upload.modal';
import { CloudDocumentExportModal } from 'src/app/modals/cloud-document/cloud-document-export.modal';
import { CloudExportChecklistItemComponent } from 'src/app/modals/cloud-document/cloud-export-checklist-item/cloud-export-checklist-item.component';
import { CloudDocumentSourceSidebarComponent } from 'src/app/modals/cloud-document/cloud-document-source-sidebar/cloud-document-source-sidebar.component';
import { CloudDocumentFileBrowserComponent } from 'src/app/modals/cloud-document/cloud-document-file-browser/cloud-document-file-browser.component';
import { CloudDocumentFileListComponent } from 'src/app/modals/cloud-document/cloud-document-file-list/cloud-document-file-list.component';
import { CloudDocumentFileGridComponent } from 'src/app/modals/cloud-document/cloud-document-file-grid/cloud-document-file-grid.component';
import { CloudDocumentDetailsPanelComponent } from 'src/app/modals/cloud-document/cloud-document-details-panel/cloud-document-details-panel.component';

@NgModule({
  declarations: [
    ReadableDateComparedWithTodayPipe,
    ActionToThePastTranslationKeyPipe,
    ActionToTranslationKeyPipe,
    TimeAgoPipe,
    byteSizePipe,
    LoadingSpinnerComponent,
    TextFilterPipe,
    SortByPipe,
    FilterPipe,
    ValueByTypePipe,
    PdfPreparationDialogForBuilder,
    PdfPreparationDialogForStatus,
    ViewXbrlOrTxtModal,
    ViewXmlModal,
    InfoButtonComponent,
    DangerInfoButtonComponent,
    CloseableInfoButtonComponent,
    StatusDisplayComponent,
    BadgeStatusDisplayComponent,
    PillBadgeStatusDisplayComponent,
    IconComponent,
    GreetUserComponent,
    ActionSummaryComponent,
    FormcontrolErrorMessagesComponent,
    BreadcrumbComponent,
    DisplayAmountBasedTranslation,
    PageSizePickerComponent,
    ToastsContainer,
    MobileOverlayComponent,
    TagStringInputComponent,
    StatusActionsTableDesktopComponent,
    StatusActionsTableMobileComponent,
    MobileRequestStatusSendgroupActionsComponent,
    StatusInfoTableDesktopComponent,
    StatusInfoTableMobileComponent,
    BuilderSendgroupTableActionsDesktopComponent,
    MobileStatusLogComponent,
    DesktopStatusLogComponent,
    DefaultTableComponent,
    DefaultMobileTableComponent,
    DesktopStatusActions,
    MobileStatusActions,
    DeadlineComponent,
    ClosableWrapperComponent,
    DocumentDetailsModal,
    ViewLongStringModal,
    EditFilingDataModalComponent,
    // Directivesk
    AutofocusDirective,
    InputTrimDirective,
    TrimDirective,
    SafeTranslateDirective,
    ColumnResizeDirective,
    // Components,
    ModalWrapperComponent,
    DateTimePickerComponent,
    LanguagePickerComponent,
    BuilderBadgeComponent,
    CreateSupportTicketModal,
    CloudDocumentUploadModal,
    CloudDocumentExportModal,
    CloudExportChecklistItemComponent,
    CloudDocumentSourceSidebarComponent,
    CloudDocumentFileBrowserComponent,
    CloudDocumentFileListComponent,
    CloudDocumentFileGridComponent,
    CloudDocumentDetailsPanelComponent,
  ], imports: [
    CommonModule,
    RouterModule, RouterOutlet, RouterLink, RouterLinkActive,
    NgbModule,
    NgbDropdownModule,
    FormsModule,
    ReactiveFormsModule,
    AngularDraggableModule,
    NgxPanZoomModule,
    InfiniteScrollModule,
    TagInputModule,
    TranslateModule.forChild({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        }
    }),
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    A11yModule,
    NgxIntlTelInputModule
],
  exports: [
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    TagInputModule,
    ReadableDateComparedWithTodayPipe,
    TimeAgoPipe,
    byteSizePipe,
    ActionToThePastTranslationKeyPipe,
    ActionToTranslationKeyPipe,
    TextFilterPipe,
    PageSizePickerComponent,
    SortByPipe,
    FilterPipe,
    ValueByTypePipe,
    ViewXbrlOrTxtModal,
    ViewXmlModal,
    FormcontrolErrorMessagesComponent,
    PdfPreparationDialogForBuilder,
    PdfPreparationDialogForStatus,
    InfoButtonComponent,
    DangerInfoButtonComponent,
    CloseableInfoButtonComponent,
    StatusDisplayComponent,
    BadgeStatusDisplayComponent,
    PillBadgeStatusDisplayComponent,
    IconComponent,
    GreetUserComponent,
    ActionSummaryComponent,
    BreadcrumbComponent,
    ToastsContainer,
    DisplayAmountBasedTranslation,
    LoadingSpinnerComponent,
    MobileOverlayComponent,
    TagStringInputComponent,
    StatusActionsTableDesktopComponent,
    StatusActionsTableMobileComponent,
    MobileRequestStatusSendgroupActionsComponent,
    StatusInfoTableDesktopComponent,
    StatusInfoTableMobileComponent,
    BuilderSendgroupTableActionsDesktopComponent,
    MobileStatusLogComponent,
    DesktopStatusLogComponent,
    DefaultTableComponent,
    DefaultMobileTableComponent,
    DesktopStatusActions,
    MobileStatusActions,
    DeadlineComponent,
    ClosableWrapperComponent,
    FormsModule,
    ReactiveFormsModule,
    DocumentDetailsModal,
    ViewLongStringModal,
    EditFilingDataModalComponent,
    BuilderBadgeComponent,
    // Directives
    TrimDirective,
    InputTrimDirective,
    SafeTranslateDirective,
    AutofocusDirective,
    ColumnResizeDirective,
    // Components,
    ModalWrapperComponent,
    DateTimePickerComponent,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgxIntlTelInputModule,
    LanguagePickerComponent,
    CloudDocumentUploadModal,
    CloudDocumentExportModal,
    CloudExportChecklistItemComponent,
    CloudDocumentSourceSidebarComponent,
    CloudDocumentFileBrowserComponent,
    CloudDocumentFileListComponent,
    CloudDocumentFileGridComponent,
    CloudDocumentDetailsPanelComponent,
  ],
  providers: [
    ReadableDateComparedWithTodayPipe,
    DatePipe,
    StringHelper,
    { provide: OwlDateTimeIntl, useClass: DefaultIntl }
  ],
})
export class SharedModule { }
